/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiPageResponseGetMaintenanceRecordResponseVoid } from '../models/ApiPageResponseGetMaintenanceRecordResponseVoid';
import type { ApiResponseGetMaintenanceRecordResponse } from '../models/ApiResponseGetMaintenanceRecordResponse';
import type { ApiResponseGetMaintenanceRecordTimelineResponse } from '../models/ApiResponseGetMaintenanceRecordTimelineResponse';
import type { ApiResponseVoid } from '../models/ApiResponseVoid';
import type { CreatedMaintenanceRecordRequestWrapper } from '../models/CreatedMaintenanceRecordRequestWrapper';
import type { Pageable } from '../models/Pageable';
import type { UpdatedMaintenanceRecordRequest } from '../models/UpdatedMaintenanceRecordRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class MaintenanceRecordControllerService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * 교환 이력 조회(단건)
   * 교환 이력을 조회합니다.
   * @returns ApiResponseGetMaintenanceRecordResponse OK
   * @throws ApiError
   */
  public getMaintenanceRecord({
    vin,
    recordId,
  }: {
    vin: string,
    recordId: number,
  }): CancelablePromise<ApiResponseGetMaintenanceRecordResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/maintenances/cars/{vin}/records/{recordId}',
      path: {
        'vin': vin,
        'recordId': recordId,
      },
    });
  }
  /**
   * 교환 이력 업데이트
   * 교환 이력을 업데이트 합니다.
   * @returns ApiResponseVoid OK
   * @throws ApiError
   */
  public updateMaintenanceRecord({
    vin,
    recordId,
    requestBody,
  }: {
    vin: string,
    recordId: number,
    requestBody: UpdatedMaintenanceRecordRequest,
  }): CancelablePromise<ApiResponseVoid> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/maintenances/cars/{vin}/records/{recordId}',
      path: {
        'vin': vin,
        'recordId': recordId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * 교환 이력 삭제
   * 교환 이력을 삭제합니다.
   * @returns ApiResponseVoid OK
   * @throws ApiError
   */
  public deleteMaintenanceRecord({
    vin,
    recordId,
  }: {
    vin: string,
    recordId: number,
  }): CancelablePromise<ApiResponseVoid> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/maintenances/cars/{vin}/records/{recordId}',
      path: {
        'vin': vin,
        'recordId': recordId,
      },
    });
  }
  /**
   * 교환 이력 조회(단건)
   * 교환 이력을 조회합니다.
   * @returns ApiResponseGetMaintenanceRecordResponse OK
   * @throws ApiError
   */
  public getMaintenanceRecord1({
    vin,
    recordId,
  }: {
    vin: string,
    recordId: number,
  }): CancelablePromise<ApiResponseGetMaintenanceRecordResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/maintenances/cars/{vin}/records/{recordId}/',
      path: {
        'vin': vin,
        'recordId': recordId,
      },
    });
  }
  /**
   * 교환 이력 업데이트
   * 교환 이력을 업데이트 합니다.
   * @returns ApiResponseVoid OK
   * @throws ApiError
   */
  public updateMaintenanceRecord1({
    vin,
    recordId,
    requestBody,
  }: {
    vin: string,
    recordId: number,
    requestBody: UpdatedMaintenanceRecordRequest,
  }): CancelablePromise<ApiResponseVoid> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/maintenances/cars/{vin}/records/{recordId}/',
      path: {
        'vin': vin,
        'recordId': recordId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * 교환 이력 삭제
   * 교환 이력을 삭제합니다.
   * @returns ApiResponseVoid OK
   * @throws ApiError
   */
  public deleteMaintenanceRecord1({
    vin,
    recordId,
  }: {
    vin: string,
    recordId: number,
  }): CancelablePromise<ApiResponseVoid> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/maintenances/cars/{vin}/records/{recordId}/',
      path: {
        'vin': vin,
        'recordId': recordId,
      },
    });
  }
  /**
   * 교환 이력 조회 (페이징)
   * 교환 이력을 조회합니다.
   * @returns ApiPageResponseGetMaintenanceRecordResponseVoid OK
   * @throws ApiError
   */
  public getMaintenanceRecords({
    vin,
    pageable,
    sestCode,
    startDate,
    endDate,
    createdBy,
  }: {
    vin: string,
    pageable: Pageable,
    sestCode?: '01' | '02' | '03' | '04' | '09' | '18' | '21',
    startDate?: string,
    endDate?: string,
    createdBy?: string,
  }): CancelablePromise<ApiPageResponseGetMaintenanceRecordResponseVoid> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/maintenances/cars/{vin}/records/',
      path: {
        'vin': vin,
      },
      query: {
        'sestCode': sestCode,
        'startDate': startDate,
        'endDate': endDate,
        'createdBy': createdBy,
        'pageable': pageable,
      },
    });
  }
  /**
   * 교환 이력 등록
   * 교환 이력을 등록합니다.)
   * @returns ApiResponseVoid OK
   * @throws ApiError
   */
  public createMaintenanceRecord({
    vin,
    requestBody,
  }: {
    vin: string,
    requestBody: CreatedMaintenanceRecordRequestWrapper,
  }): CancelablePromise<ApiResponseVoid> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/maintenances/cars/{vin}/records/',
      path: {
        'vin': vin,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * 교환 이력 조회 (페이징)
   * 교환 이력을 조회합니다.
   * @returns ApiPageResponseGetMaintenanceRecordResponseVoid OK
   * @throws ApiError
   */
  public getMaintenanceRecords1({
    vin,
    pageable,
    sestCode,
    startDate,
    endDate,
    createdBy,
  }: {
    vin: string,
    pageable: Pageable,
    sestCode?: '01' | '02' | '03' | '04' | '09' | '18' | '21',
    startDate?: string,
    endDate?: string,
    createdBy?: string,
  }): CancelablePromise<ApiPageResponseGetMaintenanceRecordResponseVoid> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/maintenances/cars/{vin}/records',
      path: {
        'vin': vin,
      },
      query: {
        'sestCode': sestCode,
        'startDate': startDate,
        'endDate': endDate,
        'createdBy': createdBy,
        'pageable': pageable,
      },
    });
  }
  /**
   * 교환 이력 등록
   * 교환 이력을 등록합니다.)
   * @returns ApiResponseVoid OK
   * @throws ApiError
   */
  public createMaintenanceRecord1({
    vin,
    requestBody,
  }: {
    vin: string,
    requestBody: CreatedMaintenanceRecordRequestWrapper,
  }): CancelablePromise<ApiResponseVoid> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/maintenances/cars/{vin}/records',
      path: {
        'vin': vin,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * 10년치 교체이력 조회
   * 해당 차량의 최근 10년간 교체이력을 날짜별로 그룹핑하여 조회합니다.
   * @returns ApiResponseGetMaintenanceRecordTimelineResponse OK
   * @throws ApiError
   */
  public getMaintenanceRecordTimeline({
    vin,
  }: {
    vin: string,
  }): CancelablePromise<ApiResponseGetMaintenanceRecordTimelineResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/maintenances/cars/{vin}/records/timeline',
      path: {
        'vin': vin,
      },
    });
  }
  /**
   * 10년치 교체이력 조회
   * 해당 차량의 최근 10년간 교체이력을 날짜별로 그룹핑하여 조회합니다.
   * @returns ApiResponseGetMaintenanceRecordTimelineResponse OK
   * @throws ApiError
   */
  public getMaintenanceRecordTimeline1({
    vin,
  }: {
    vin: string,
  }): CancelablePromise<ApiResponseGetMaintenanceRecordTimelineResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/maintenances/cars/{vin}/records/timeline/',
      path: {
        'vin': vin,
      },
    });
  }
  /**
   * 최근 교환 이력 조회
   * 최근 교환 이력을 조회합니다.
   * @returns ApiResponseGetMaintenanceRecordResponse OK
   * @throws ApiError
   */
  public getMostRecentMaintenanceRecord({
    vin,
    sestCode,
  }: {
    vin: string,
    sestCode: '01' | '02' | '03' | '04' | '09' | '18' | '21',
  }): CancelablePromise<ApiResponseGetMaintenanceRecordResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/maintenances/cars/{vin}/records/recent',
      path: {
        'vin': vin,
      },
      query: {
        'sestCode': sestCode,
      },
    });
  }
  /**
   * 최근 교환 이력 조회
   * 최근 교환 이력을 조회합니다.
   * @returns ApiResponseGetMaintenanceRecordResponse OK
   * @throws ApiError
   */
  public getMostRecentMaintenanceRecord1({
    vin,
    sestCode,
  }: {
    vin: string,
    sestCode: '01' | '02' | '03' | '04' | '09' | '18' | '21',
  }): CancelablePromise<ApiResponseGetMaintenanceRecordResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/maintenances/cars/{vin}/records/recent/',
      path: {
        'vin': vin,
      },
      query: {
        'sestCode': sestCode,
      },
    });
  }
}
